import { PresenceIndicator } from '../badges/PresenceIndicator';
import { SequenceFlagBadge } from '../badges/SequenceFlagBadge';

import type { SequenceVM } from '../../view-models';
import type React from 'react';

export interface SequenceRiskCardProps {
  seq: SequenceVM;
  onSeeConversation?: () => void;
  onDrillDown?: () => void;
}

export function SequenceRiskCard({
  seq,
  onSeeConversation,
  onDrillDown,
}: SequenceRiskCardProps): React.JSX.Element {
  return (
    <div className="seq-card">
      <div className="seq-card__head">
        {seq.flags.map((f) => (
          <SequenceFlagBadge key={f} flag={f} />
        ))}
      </div>
      <div className="seq-card__meta">
        <b>{seq.person}</b> · Bond: {seq.bond}
      </div>
      <div className="seq-card__meta">
        <b>{seq.conversations}</b> conversas
        {seq.period !== undefined && ` em ${seq.period}`}
        {' · '}sentimento <b>{seq.sentiment}</b>
      </div>
      <div className="seq-card__meta">
        Atendente: <b>{seq.attendant.name}</b>{' '}
        <PresenceIndicator presence={seq.attendant.presence} />
      </div>
      <div className="seq-card__actions">
        {/* Item 354: "Ver conversa atual" salta p/ a conversa atual da sequence
            (/atendimento/conversation/:id). Gate visual honesto (espelha o "Drill down"):
            desabilitado quando a page não passa o handler — sem core-conversation OU sem
            conversationId resolvido no backend. */}
        <button
          type="button"
          className="btn-ghost-mini"
          disabled={onSeeConversation === undefined}
          title={
            onSeeConversation === undefined
              ? 'Disponível quando a sequência tem conversa vinculada e você pode abrir conversas'
              : undefined
          }
          onClick={onSeeConversation}
        >
          Ver conversa atual
        </button>
        {/* Item 353: "Drill down" salta p/ a Pessoa da sequence (/pessoas/:id). Gate visual
            honesto (espelha AttendantDrawerStub): desabilitado quando a page não passa o
            handler — sem person-read OU sem personId resolvido no backend. */}
        <button
          type="button"
          className="btn-ghost-mini"
          disabled={onDrillDown === undefined}
          title={
            onDrillDown === undefined
              ? 'Disponível quando a sequência tem Pessoa vinculada e você pode abrir fichas de Pessoas'
              : undefined
          }
          onClick={onDrillDown}
        >
          Ver pessoa
        </button>
      </div>
    </div>
  );
}
